/**
 * Personalized homepage
 */
if (localStorage) {
  var SECTION_LIMIT = 2;

  // Get storage data
  var STORAGE_KEY = 'pxt_collection_engagement';
  var existingCountsJson = localStorage.getItem(STORAGE_KEY) || '{}';
  var existingCounts = JSON.parse(existingCountsJson);

  // Get most popular collections
  var sortable = [];
  for (var collection in existingCounts) {
      sortable.push([collection, existingCounts[collection]]);
  }
  sortable.sort(function(a, b) { return b[1] - a[1]  });

  // Find most popluar collection listing
  var visibleSectionCount = 0;

  for (var i = 0; i < sortable.length; i++) {
    var collectionData = sortable[i];
    var collectionHandle = collectionData[0];
    var section = $('.Personalized--' + collectionHandle);

    if (section.length > 0) {
      section.show();
      visibleSectionCount += 1;
      
      if (visibleSectionCount >= SECTION_LIMIT) {
        break;
      }
    }
  }
}


/**
 * Instagram Slider
 */
$('.js-instagram-list').slick({
  slidesToShow: 5,
  infinite: true,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '30px'
      },
    },
  ]
});